/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ConvertOptionsComponent } from "../../components/workspace/convert-options/convert-options.component";
import { ConvertOptions } from "../../models/convert-options-info";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class PlaceCouplingDialog implements PopupDialog {

  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component =ConvertOptionsComponent ;
   const convertOptions = new ConvertOptions();
    
   convertOptions.systemName="MySystem";
    sysquePopupConfig.data = convertOptions;
    sysquePopupConfig.component.data = sysquePopupConfig.data
    sysquePopupConfig.width = 641;
    sysquePopupConfig.height = 678;
    sysquePopupConfig.componentTitle = "Place Couplings";
  }
}
